import styled from 'styled-components';
import IconButton from '../../buttons/IconButton';

export const StyledMoreMenuIcon = styled(IconButton)`
  border-radius: 50%;

  &:hover:not(:disabled) {
    border: solid 1px ${({ theme }) => theme.colors.blue5};
  }

  &:focus:not(:disabled) {
    border: solid 1px ${({ theme }) => theme.colors.blue5};
  }

  &:active:not(:disabled) {
    border: solid 2px ${({ theme }) => theme.colors.blue10};
  }
`;
